import { render, staticRenderFns } from "./vButton.vue?vue&type=template&id=1710dbc0&scoped=true"
import script from "./vButton.vue?vue&type=script&lang=ts"
export * from "./vButton.vue?vue&type=script&lang=ts"
import style0 from "./vButton.vue?vue&type=style&index=0&id=1710dbc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1710dbc0",
  null
  
)

export default component.exports